export default "__VITE_ASSET__cd72eb1e__"